import { Injectable } from '@angular/core'
import { IApplicationReassignmentNotification } from '@candidate/app/models/app-notification.model'
import { INotificationHandler, INotificationView, UserAppNotificationService } from '@engineering11/notifications-web'
import { CandidateHomeNavigationService } from '../candidate-home-navigation.service'

@Injectable({ providedIn: 'root' })
export class ApplicationReassignmentNotificationHandler implements INotificationHandler<IApplicationReassignmentNotification, INotificationView> {
  notificationType = 'candidate_application_reassignment'
  constructor(
    private candidateHomeNavigationService: CandidateHomeNavigationService,
    private userAppNotificationService: UserAppNotificationService
  ) {}

  onClick(notification: IApplicationReassignmentNotification): boolean | Promise<boolean> {
    if (!notification.viewed) {
      this.userAppNotificationService.markNotificationAsRead(notification.id)
    }
    return this.candidateHomeNavigationService.jobApplication(notification.jobPostId)
  }
}
